import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Image from 'react-bootstrap/Image'
import Container from 'react-bootstrap/Container'
import { Link } from 'react-router-dom'
import NavbarOffcanvas from './NavbarOffcanvas'
import Menu from '../../assets/icons/header/menu.svg'
import Logo from '../../assets/logo/logo.png'
import './header.css'

function HomeHeader() {
  const [showMenu, setShowMenu] = React.useState(false)

  return (
    <Navbar
      fixed='top'
      collapseOnSelect
      expand='lg'
      className='ag-top-nav'
    >
      <Container>
          <div className='ag-top-nav__inner'>
            <Link className='ag-top-nav__brand' to={'/'}>
              <Image src={Logo} alt='Actual Green Corporation' />
            </Link>

            <div className='ag-top-nav__menu'>
              <div className='d-lg-none'>
                <Navbar.Toggle
                  className='ag-top-nav__toggle'
                  aria-controls='responsive-navbar-nav'
                  onClick={() => setShowMenu(!showMenu)}
                >
                  <Image src={Menu} alt='Menu' />
                </Navbar.Toggle>
              </div>
              <NavbarOffcanvas showMenu={showMenu} setShowMenu={setShowMenu} />
            </div>
          </div>
      </Container>
    </Navbar>
  )
}

export default HomeHeader
